import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {ExternalLinkCloseButtonWrapperDefaultBox} from "./external-link-close-button-wrapper.default.box";

export const ExternalLinkCloseButtonWrapperBox = styledByTheme(ExternalLinkCloseButtonWrapperDefaultBox).apply();

